var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"page-loading",on:{"click":function($event){$event.stopPropagation();}}},[_c('van-loading',{attrs:{"type":"spinner","color":"#1989fa"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }